module.exports = __webpack_public_path__ + "static/img/page_bg.6cfb97c7.png";